module.exports = __webpack_public_path__ + "media/townhome.819a59a8.svg";